<template>
  <div>
    <H4 class="text-danger">
      An error has occurred.
    </H4>
    <div>Please forgive us, as an error has occurred in the system.  Please select an item from the left to continue.  If the issue persists, please contact support.</div>
    <div>{{ errormsg }}</div>
  </div>
</template>

<script>
export default {
  name: 'Oops',
  props: {
    errormsg: {
      type: String,
      default: ''
    }
  }
}
</script>
